import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * Compact one-line disclaimer shown next to the ANAF submit action.
 * Required by Terms §9.1 — EZ Factura is a technical bridge, not a fiscal
 * representative. Kept intentionally minimal so it doesn't add UX friction.
 */
const AnafDisclaimerFooter = ({ className }: { className?: string }) => {
  return (
    <p
      className={cn(
        "text-[11px] leading-relaxed text-muted-foreground/80 text-center",
        className,
      )}
    >
      Răspunderea pentru acuratețea facturii îți aparține.{" "}
      <Link
        to="/terms#anaf-disclaimer"
        className="underline underline-offset-2 hover:text-foreground transition-colors"
      >
        Detalii §9.1
      </Link>
    </p>
  );
};

export default AnafDisclaimerFooter;
